// extracted by mini-css-extract-plugin
module.exports = {"root":"UniversalFormat_root__H9q6R","description":"UniversalFormat_description__0X2_S","ui":"UniversalFormat_ui__EXNlG"};